import UploadXMl from "api/uploadXML";
import { AccountContext } from 'components/Account/Account';
import { useContext, useState, useRef } from "react";
import { Container, Modal, Spinner, Button, Card } from "react-bootstrap";

function UploadXMLCAF() {
  const [modalDescarga, setModalDescarga] = useState(false);
  const [loading, setloading] = useState(true);
  const [modalMensaje, setmodalMensaje] = useState('');
  const [errorUpload, seterrorUpload] = useState(false);
  const { getSession } = useContext(AccountContext);
  const [jsonResponse, setjsonResponse] = useState({});

  const hiddenFileInput = useRef(null);

  const closeModal = () => setModalDescarga(false);

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const handleClick = () => hiddenFileInput.current.click();

  const getBinaryFromFile = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.addEventListener('load', () => resolve(reader.result));
      reader.addEventListener('error', (err) => reject(err));
      reader.readAsText(file, 'UTF-8');
    });

  const handleChange = async (event) => {
    const fileUploaded = event.target.files[0];
    if (!fileUploaded) return;

    setModalDescarga(true);
    setloading(true);
    seterrorUpload(false);

    try {
      const binary = await getBinaryFromFile(fileUploaded);
      await sleep(2000);
      const idToken = await getSession().then((session) => session.idToken.jwtToken);
      const response = await UploadXMl(binary, idToken);
      setmodalMensaje('CAF subido correctamente');
      setjsonResponse(response.data);
      seterrorUpload(false);
      setloading(false);
    } catch (error) {
      setloading(false);
      seterrorUpload(true);
      const apiMessage = error?.response?.data?.message;
      if (apiMessage === 'Caf duplicado') {
        setmodalMensaje('CAF duplicado');
      } else {
        setmodalMensaje('Error al insertar CAF');
      }
    }

    if (hiddenFileInput.current) {
      hiddenFileInput.current.value = null;
    }
  };

  return (
    <>
      <Container fluid className="page-container">
        <div className="page-header">
          <div>
            <h2 className="page-title">Subir CAF</h2>
            <p className="page-subtitle">
              Carga un archivo XML CAF (Código de Autorización de Folios) para registrar nuevos folios.
            </p>
          </div>
        </div>

        <Card className="data-card">
          <Card.Body>
            <div className="upload-zone">
              <div className="upload-zone__icon">
                <i className="nc-icon nc-cloud-upload-94" />
              </div>
              <div className="upload-zone__text">
                <span className="upload-zone__title">Selecciona un archivo XML</span>
                <span className="upload-zone__subtitle">Solo archivos .xml de CAF emitidos por el SII</span>
              </div>
              <Button className="btn-primary-action btn-primary-action--inline" onClick={handleClick}>
                <i className="nc-icon nc-cloud-upload-94" />
                Subir archivo
              </Button>
              <input
                type="file"
                accept=".xml"
                ref={hiddenFileInput}
                onChange={handleChange}
                style={{ display: 'none' }}
              />
            </div>
          </Card.Body>
        </Card>
      </Container>

      <Modal show={modalDescarga} centered backdrop="static">
        <Modal.Header closeButton={!loading}>
          <Modal.Title>
            {loading ? 'Subiendo CAF' : modalMensaje}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="result-loading">
              <Spinner animation="border" role="status" />
              <span>Procesando archivo...</span>
            </div>
          ) : errorUpload ? (
            <div className="result-error">{modalMensaje}</div>
          ) : (
            <div className="result-grid">
              <div className="result-grid__header">
                <span className="result-grid__folio-label">Resultado</span>
                <span className="status-badge status-badge--success">CAF cargado</span>
              </div>
              <div className="result-grid__row">
                <span className="result-grid__label">Rut</span>
                <span className="result-grid__value">{jsonResponse.rut}</span>
              </div>
              <div className="result-grid__row">
                <span className="result-grid__label">Folio inicio</span>
                <span className="result-grid__value">{jsonResponse.min_folio}</span>
              </div>
              <div className="result-grid__row">
                <span className="result-grid__label">Folio fin</span>
                <span className="result-grid__value">{jsonResponse.max_folio}</span>
              </div>
              <div className="result-grid__row">
                <span className="result-grid__label">Tipo documento</span>
                <span className="result-grid__value">{jsonResponse.tipodocumento}</span>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {!loading && (
            <Button variant="secondary" onClick={closeModal}>
              Cerrar
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default UploadXMLCAF;
